import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_STATE } from "../initialState";

export const accountSlice = createSlice({
  name: "accountData",
  initialState: INITIAL_STATE,
  reducers: {
    setUserData: (state, action) => {
      state.userData = {
        ...state.userData,
        ...action.payload,
      };
    },
    setAuthDetails: (state, action) => {
      state.authDetails = action.payload;
    },
    setUserProfile: (state, action) => {
      state.userData = {
        ...state.userData,
        ...action.payload,
      };
    },
    setLoginPopSate: (state, action) => {
      state.ui.loginPopOpen = action.payload;
    },
    setChangePopSate: (state, action) => {
      state.ui.changePasswordPopOpen = action.payload;
    },
    setChangeButtonState: (state, action) => {
      state.ui.changeButtonPopOpen = action.payload;
    },
    setMyMarketPopState: (state, action) => {
      state.ui.myMarketPopOpen = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setToken: (state, action) => {
      state.userData.token = action.payload;
    },
    setDynamicOperatorId: (state, action) => {
      state.userData.dynamicOperatorId = action.payload;
    },
    setAllowedGames: (state, action) => {
      let games = action.payload || [];
      // Backend may return allowedGames as a JSON string — parse it
      if (typeof games === "string") {
        try {
          games = JSON.parse(games);
        } catch {
          games = [];
        }
      }
      // Backend may return a JSON array split by commas into fragments
      // e.g. ['["dragonTiger20"', '"dragonTiger202"', ..., '"superOver"]']
      // Join and re-parse to get clean values
      if (Array.isArray(games) && games.length > 0 && typeof games[0] === "string") {
        const first = games[0];
        if (first.startsWith("[") || first.startsWith('"') || first.includes('\\"')) {
          try {
            const joined = games.join(",");
            const parsed = JSON.parse(joined);
            if (Array.isArray(parsed)) {
              games = parsed;
            }
          } catch {
            // Fallback: strip extra quotes/brackets from each element
            games = games.map((g) => g.replace(/[\[\]"\\]/g, "").trim()).filter(Boolean);
          }
        }
      }
      state.allowedGames = Array.isArray(games) ? games : [];
    },
    logOut: (state, action) => {
      state.userData = {};
      state.allowedGames = [];
    },
  },
});
export const { setUserData, setUserProfile, setLoginPopSate, setAuthDetails, setDynamicOperatorId, setAllowedGames } =
  accountSlice.actions;
export default accountSlice.reducer;
